import { Button, Flex, useTheme, spacing } from '@fti/design-system';

interface ProjectFiltersProps {
  status: string;
  onStatusChange: (s: string) => void;
  scope: 'mine' | 'all';
  onScopeChange: (s: 'mine' | 'all') => void;
  isAdmin: boolean;
}

const STATUS_OPTIONS = [
  { value: '', label: 'All Statuses' },
  { value: 'draft', label: 'Draft' },
  { value: 'active', label: 'Active' },
  // 'Archived' removed for now — no way to archive a project yet (no backend
  // transition). Re-add here if/when archiving is implemented.
];

export function ProjectFilters({
  status,
  onStatusChange,
  scope,
  onScopeChange,
  isAdmin,
}: ProjectFiltersProps) {
  const { theme } = useTheme();

  return (
    <Flex justify="between" align="center">
      <select
        value={status}
        onChange={(e) => onStatusChange(e.target.value)}
        style={{
          padding: `${spacing.xs} ${spacing.sm}`,
          border: `1px solid ${theme.colors.border.default}`,
          borderRadius: '4px',
          backgroundColor: theme.colors.background.paper,
          color: theme.colors.text.primary,
          fontSize: '0.9rem',
        }}
      >
        {STATUS_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {isAdmin && (
        <Flex gap="xs">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onScopeChange('mine')}
            style={{
              fontWeight: scope === 'mine' ? 600 : 400,
              backgroundColor: scope === 'mine' ? theme.colors.primary[100] : 'transparent',
            }}
          >
            Mine
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onScopeChange('all')}
            style={{
              fontWeight: scope === 'all' ? 600 : 400,
              backgroundColor: scope === 'all' ? theme.colors.primary[100] : 'transparent',
            }}
          >
            All
          </Button>
        </Flex>
      )}
    </Flex>
  );
}
